import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import type { PeriodoEstatisticasPreset } from "services/estatisticasDashboard";

type Props = {
  value: PeriodoEstatisticasPreset;
  onChange: (value: PeriodoEstatisticasPreset) => void;
};

const OPTIONS: { value: PeriodoEstatisticasPreset; label: string }[] = [
  { value: "ytd", label: "Ano (atual)" },
  { value: "mes", label: "Este mês" },
  { value: "ano_anterior", label: "Ano anterior" },
];

export default function EstatisticasPeriodoFilter({ value, onChange }: Props) {
  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={value}
      onChange={(_, next: PeriodoEstatisticasPreset | null) => {
        if (next) onChange(next);
      }}
      sx={{
        flexShrink: 0,
        "& .MuiToggleButton-root": {
          px: 1.5,
          py: 0.75,
          textTransform: "none",
          fontSize: "0.8125rem",
        },
      }}
    >
      {OPTIONS.map((opt) => (
        <ToggleButton key={opt.value} value={opt.value}>
          {opt.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
